import { useEffect, useState } from 'react';

import { getOrganizations } from '@/apis/user';
import type { Department } from '@/types/user';

export const initDepartMent = {
  ID: '',
  name: '',
  children: [],
  members: [],
} as Department;

const useDepartmentModel = () => {
  const [departmentData, setDepartmentData] = useState<Department>();

  useEffect(() => {
    const getDepartmentData = async () => {
      try {
        const data = await getOrganizations();
        setDepartmentData(data.organization);
      } catch (err) {
        console.error(err);
      }
    };

    if (!departmentData) {
      getDepartmentData();
    }
  }, [departmentData]);

  return {
    departmentData: departmentData || initDepartMent,
  };
};

export default useDepartmentModel;
